<template>
  <div class="web">
    <div class="header" v-show="flag">
      <div class="header_con">
        <img src="@/assets/images/web/logoh.png" alt="" />
        <div class="nav">
          <p>首页</p>
          <p>南阳链</p>
          <p>联系我们</p>
        </div>
      </div>
    </div>
    <div class="banner">
      <div class="banner_con">
        <img
          class="banner_img"
          src="@/assets/images/web/banner.png"
          alt=""
          width="100%"
        />
        <div class="con">
          <div class="des1">区块链未来，共享更精彩</div>
          <div class="des2">
            以数字科技打造南阳“区块链+”产业集群，以区块链技术，推进<br />
            数字产业链。
          </div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="title">南阳链</div>
      <div class="des">南阳“区块链+”产业集群</div>
      <div class="list_con">
        <div class="item">
          <img src="@/assets/images/web/item1.png" alt="" />
          <p class="title">自主创新</p>
          <p class="des">
            完成对区块链技术核心知识产权的自主研发。将区块链技术与如物联网、大数据、人工智能等其他新兴技术相结合，最大化发挥其效能。
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/web/item2.png" alt="" />
          <p class="title">安全高效</p>
          <p class="des">
            以安全高效为平台建设目标，搭建诚实可靠简单高效的区块链平台。分布式记账，各节点加密传输数据，各节点储存完整的交易信息，让交易处理更加安全且高效快捷。
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/web/item3.png" alt="" />
          <p class="title">开放分享</p>
          <p class="des">
            始于南阳，走出河南，目标全国。南阳链将搭建区块链基础设施，开放内部服务能力，与行业伙伴共享，共同推动可信互联网的发展，打造区块链的共赢生态。
          </p>
        </div>
      </div>
    </div>
    <div class="form">
      <div class="title">申请加入南阳链</div>
      <div class="des">请填写以下内容，我们会很快与您联系</div>
      <div class="form_con">
        <a-form-model ref="ruleForm" layout="vertical" :model="form" :rules="rules">
          <a-form-model-item label="企业名称" prop="cstName">
            <a-input v-model="form.cstName" placeholder="请输入您的名字" />
          </a-form-model-item>
          <a-form-model-item label="联系电话" prop="concatPhone">
            <a-input v-model="form.concatPhone" placeholder="请输入您的电话号码" />
          </a-form-model-item>
          <a-form-model-item label="联系人名称" prop="concatPerson">
            <a-input v-model="form.concatPerson" placeholder="请输入联系人名称" />
          </a-form-model-item>
          <a-form-model-item label="邮箱" prop="concatEmail">
            <a-input v-model="form.concatEmail" placeholder="请输入您的邮箱" />
          </a-form-model-item>
        </a-form-model>
        <div class="des">
          点击“提交”后我们会使用您的信息与您联系，告知您相关动态和特别优惠。请您确保信息准确无误，以便我们的客服专员联系您。
        </div>
        <div class="btn_box">
          <a-button class="btn" type="primary" @click="handleSave"> 提交 </a-button>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer_top">
        <img src="@/assets/images/web/logof.png" alt="" />
        <div class="nav">
          <p>商祺数贸</p>
          <p>南阳链</p>
          <p>联系我们</p>
        </div>
      </div>
      <div class="footer_bottom">
        Copyright@2023&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;All rights
        reserved.豫ICP备2023000680号
      </div>
    </div>
  </div>
</template>

<script>
import { joinSave } from "@/api/web.js";
export default {
  data() {
    return {
      flag: true,
      form: {
        cstName: undefined,
        concatPhone: undefined,
        concatPerson: undefined,
        concatEmail: undefined,
      },
      rules: {
        cstName: [{ required: true, message: "请输入您的名字", trigger: "blur" }],
        concatPhone: [{ required: true, message: "请输入您的电话号码", trigger: "blur" }],
        concatPerson: [{ required: true, message: "请输入联系人名称", trigger: "blur" }],
        concatEmail: [{ required: true, message: "请输入您的邮箱", trigger: "blur" }],
      },
    };
  },
  mounted() {
    window.addEventListener("scroll", this.scrollTop);
  },
  methods: {
    handleSave() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          joinSave(this.form).then((res) => {
            this.form = {
              cstName: undefined,
              concatPhone: undefined,
              concatPerson: undefined,
              concatEmail: undefined,
            }
            this.$message.success('提交成功')
          });
        } else {
          return false;
        }
      });
    },
    scrollTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      this.flag = top > 550 ? false : true;
    },
  },
};
</script>

<style lang="less" scoped>
.web {
  min-width: 1400px;
  font-family: SourceHanSansSC-Regular, SourceHanSansSC;
}
p {
  margin: 0;
  padding: 0;
}
.title {
  font-size: 52px;
  font-weight: bold;
  color: #060606;
  line-height: 77px;
  text-align: center;
}
.des {
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: #8a8b8c;
  line-height: 24px;
}
.header {
  width: 100%;
  height: 64px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(12px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  .header_con {
    width: 1192px;
    height: 64px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      height: 40px;
    }
    .nav {
      font-size: 14px;
      color: #ffffff;
      display: flex;
      p {
        margin-left: 48px;
      }
    }
  }
}
.banner_con {
  position: relative;

  .con {
    margin-top: 20%;
    width: 1192px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%);
    z-index: 99;
  }

  .des1 {
    font-size: 56px;
    font-family: SourceHanSansSC-Heavy, SourceHanSansSC;
    font-weight: 800;
    color: #ffffff;
    line-height: 83px;
  }

  .des2 {
    margin-top: 20px;
    font-size: 24px;
    font-family: SourceHanSansSC-Regular, SourceHanSansSC;
    font-weight: 400;
    color: #ffffff;
    line-height: 36px;
  }
}

.list {
  width: 100%;
  background: #ececf2;
  padding-top: 120px;
  padding-bottom: 153px;

  .list_con {
    width: 1192px;
    margin: 48px auto 0;
    display: flex;
    justify-content: space-between;
    .item {
      width: 384px;
      height: 422px;
      background: #ffffff;
      box-shadow: 0px 20px 32px 0px rgba(0, 29, 49, 0.05);
      border: 1px solid #ececf2;
      overflow: hidden;
      img {
        width: 100%;
        height: 240px;
      }
      .title {
        font-size: 20px;
        font-weight: bold;
        color: #060606;
        line-height: 29px;
        text-align: left;
        margin-top: 20px;
        padding-left: 24px;
      }
      .des {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
        text-align: justify;
        padding: 0 24px;
        margin-top: 5px;
      }
    }
  }
}
.form {
  background: url("~@/assets/images/web/frombg.png") no-repeat center;
  background-size: cover;
  padding-top: 90px;
  padding-bottom: 66px;
  .form_con {
    width: 564px;
    margin: 70px auto 0;
    .ant-input {
      height: 44px;
      background: #ffffff !important;
      border-radius: 2px;
      border: 1px solid #dcdee0 !important;
    }
    .des {
      font-size: 14px;
      font-weight: 400;
      color: #6e6e6e;
      line-height: 20px;
      text-align: left;
    }
    .btn_box {
      text-align: center;
    }
    .btn {
      width: 172px;
      height: 48px;
      background: #001762 !important;
      border-radius: 4px;
      margin-top: 36px;
      border: 0 !important;
    }
  }
}
.footer {
  width: 100%;
  height: 202px;
  background: #ecf1fd;
  .footer_top {
    width: 1192px;
    height: 145px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img {
      width: 96px;
      height: 48px;
    }
    .nav {
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      line-height: 20px;
      display: flex;
      p {
        margin-left: 104px;
      }
    }
  }
  .footer_bottom {
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    line-height: 56px;
    border-top: 1px solid #e0e0e0;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/web/index.vue